import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import {QuoteService} from '../../../quote.service';
import { formatDate } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'ngx-webstorage';
import { PolicyService } from '../../../../policy/policy.service';
import {SharedService} from '../../../../services/shared.service';
import { environment } from 'src/environments/environment';
import { BreakdownService } from '../../breakdown.service';

/** Document type ids for breakdown/quote/documents API: 1=quote, 2=policy, 3=MTA, 4=cancellation */
const DOCUMENT_TYPE_LABELS: { [key: number]: string } = {
  1: 'Quote',
  2: 'Policy',
  3: 'MTA',
  4: 'Cancellation'
};

/** Resolve document type from current quote: 1=quote, 2=policy, 3=MTA, 4=cancellation */
function getDocumentTypeForQuote(quote: any): number {
  if (!quote) return 1;
  if (Number(quote.is_policy) === 1) {
    const type = Number(quote.type);
    if (type === 3) return 3;   // MTA
    if (type === 4) return 4;   // Cancellation
    return 2;                    // Policy (new business/renewal)
  }
  return 1;                      // Quote (not yet converted)
}

@Component({
  selector: 'app-breakdown-documents',
  templateUrl: './breakdown-documents.component.html',
  styleUrls: ['./breakdown-documents.component.css', '../../../quote.component.css']
})
export class BreakdownDocumentsComponent implements OnInit {
  @Input() public quote;
  public rowData: any;
  public rowDataPeliwica: any;
  public isAdmin: boolean = false;
  public isInsurer: boolean = false;
  public isPolicy: boolean = false;

  constructor(
    private quoteService: QuoteService, 
    private policyService: PolicyService, 
    private sharedService: SharedService,
    private _snackBar: MatSnackBar, 
    private modalService: NgbModal, 
    private sessionSt: LocalStorageService,
    private breakdownService: BreakdownService
  ) { }


  public ngOnChanges(changes: SimpleChanges) {
    if (this.sessionSt.retrieve('quote_ref_id')) {
      this.isPolicy = true;
    }

    // Peliwica Documents
    this.getDocuments();
  }


  public ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_insurer')) {
      this.isInsurer = true;
    }
  }

  /*
  * Get documents for the document type that matches the current quote (1=quote, 2=policy, 3=MTA, 4=cancellation).
  */
  public getDocuments() {
    if (!this.quote || !this.quote.id) {
      return;
    }
    const quoteId = this.quote.id;
    const isUnderwritten = this.quote.is_underwritten != null ? Number(this.quote.is_underwritten) : 0;
    const docType = getDocumentTypeForQuote(this.quote);
    const isInsurer = this.sessionSt.retrieve('is_insurer');
    const isPolicy = this.quote.is_policy;

    this.breakdownService.getQuoteDocuments(quoteId, docType, isUnderwritten).subscribe(
      (response: any) => {
        if (response && response.success && Array.isArray(response.result)) {
          let rows = (response.result as any[]).map((doc: any) => ({
            ...doc,
            document_type: docType,
            document_type_label: DOCUMENT_TYPE_LABELS[docType] || String(docType),
            is_policy: isPolicy,
            isInsurer: isInsurer || false
          }));
          if (this.quote.product_id == environment.AMLINE_ID && this.quote.is_send_email == 1) {
            rows = rows.filter(doc =>
              !(doc.document_type === 2 && (doc.title === 'Broker Letter' || doc.title === 'Customer Letter'))
            );
          }
          this.rowDataPeliwica = rows;
        } else {
          this.rowDataPeliwica = [];
        }
      },
      (error) => {
        this.rowDataPeliwica = [];
      }
    );
  }

  // List Quote Versions
  gridOptions: GridOptions = {
    onGridReady: () => {
      this.gridOptions.api.sizeColumnsToFit();
    }
  };
  columnDefs = [
    {
      headerName: 'Document Name', field: 'key', sortable: true, width: 500, filter: false,
      cellRenderer: function (params) {
        return params.data.value.name;
      }
    },
    {
      headerName: 'Document Type', field: 'key', sortable: true, width: 500, filter: false,
      cellRenderer: function (params) {
        return params.data.value.type;
      }
    },
    {
      headerName: null,
      width: 130, filter: false, type: 'rightAligned',
      cellRenderer: function (params) {
        let links = '';
        links += '<a class="ml-2" href="' + params.data.value.file_path + '" download target="_blank" title="Download Document" style="font-size: 18px;color: #138a51;" ><i class="mdi mdi-cloud-download"  data-action-type="download"></i></a>';
        return links;
      }
    }
  ];
  columnDefsPeliwica = [
    {
      headerName: 'Document Type', field: 'document_type_label', sortable: true, width: 120, filter: false,
      cellRenderer: function (params) {
        return params.data.document_type_label || '';
      }
    },
    {
      headerName: 'Document Name', field: 'key', sortable: true, width: 400, filter: false,
      cellRenderer: function (params) {
        return params.data.title;
      }
    },
    {
      headerName: 'Document Version', field: 'quote_version', sortable: true, width: 150, filter: false,
      cellRenderer: function (params) {
        return params.data.quote_version;
      }
    },
    {
      headerName: null,
      width: 130, filter: false, type: 'rightAligned',
      cellRenderer: function (params) {
        let links = '';
        // links += '<a class="ml-2" href="' + params.data.download_path + '" download target="_blank" title="Download Document" style="font-size: 18px;color: #138a51;" ><i class="mdi mdi-cloud-download"  data-action-type="download"></i></a>';
        links += '<a class="ml-2" title="Download Document" style="font-size: 18px;color: #138a51;"><i class="mdi mdi-cloud-download"  data-action-type="download"></i></a>';
        return links;
      }
    }
  ];


  /*
   * GRID BUTTONS ACTION
   */
  documentsEditMode: boolean = false;
  documentID: string = '';
  onGridRowClicked(e: any, content, documentsDelete) {
    if (e) {
      let actionType = e.event.target.getAttribute("data-action-type");
      switch (actionType) {
        case "download":
          {
            this.quoteService.downloadDocs(e.data);
            break;
          }
      }
    }
  }

  /*
   * Upload Documents
   */
  docTitle: string = '';
  fileToUpload: File = null;
  openDocumentsPopup(content) {
    this.documentID = '';
    this.docTitle = '';
    this.fileToUpload = null;
    this.quote.quote_document = '';
    this.documentsEditMode = false;
    this.modalService.open(content, { centered: true });
  }

  // UPLOAd DOCUMENT
  getUploadedFile(files) {
    this.fileToUpload = files.item(0);
    this.quote.quote_document = this.fileToUpload.name;
  }


  documentUpload() {
    let formData = new FormData();
    formData.append("file_name", this.fileToUpload);
    formData.append("quote_id", this.quote.id);
    formData.append("broker_id", this.quote.broker_id);
    formData.append("title", this.docTitle);

    this.quoteService.saveQuoteDocument(formData, this.quote.is_policy)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.getDocuments();
            this.modalService.dismissAll();
            this._snackBar.open('Document uploaded.', '', {
              duration: 5000,
            });
          } else {
            this._snackBar.open('Unable to upload document.', '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

        });
  }

  /*
   * UPDATE DOCUMENT
   */
  updateDocument() {
    let data: any = '';
    data = {
      document_id: this.documentID,
      title: this.docTitle
    };
    this.quoteService.updateDocument(data)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.modalService.dismissAll();
            this.rowData.forEach((res) => {
              if (this.documentID == res.id && res.is_static == 0) {
                res.title = this.docTitle
              }
              if (this.sessionSt.retrieve('is_insurer')) {
                res.isInsurer = true;
              }
            });
            this.gridOptions.api.setRowData(this.rowData);
            this.gridOptions.api.refreshCells();
            this._snackBar.open(response.message, '', {
              duration: 5000,
            });
          } else {
            this._snackBar.open('Unable to update title. Please try again later.', '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

        });
  }

  /*
    * Delete Document
    */
  deleteDocument() {
    let data: any = '';
    data = {
      document_id: this.documentID
    };
    this.quoteService.deleteDocument(data)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.modalService.dismissAll();
            let rowsDoc = [];
            this.rowData.forEach((res) => {
              if (this.documentID != res.id) {
                rowsDoc.push(res);
              }
              if (this.sessionSt.retrieve('is_insurer')) {
                res.isInsurer = true;
              }
            });
            const selectedRow = this.gridOptions.api.getFocusedCell()
            const id = this.gridOptions.rowData[selectedRow.rowIndex].i

            this.gridOptions.rowData.splice(selectedRow.rowIndex, 1)
            this.gridOptions.api.setRowData(this.gridOptions.rowData)

            this._snackBar.open(response.message, '', {
              duration: 5000,
            });
          } else {
            this._snackBar.open(response.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

        });
  }

  /*
  * Regenerate Schedule
  */
  schMsg: string = '';
  regenerate_schedule(reSchedule) {
    this.policyService.regenerateSchedule(this.quote.id, this.quote.is_policy)
      .subscribe(
        (response: any) => {
          this.getDocuments();
          this.schMsg = response.message;
          this.modalService.open(reSchedule, { centered: true });
        });
  }

  vetCertMsg;
  certMsgStyle;
  is_vet_cert_uploaded(event, vetCert) {
    if (event.target.checked) {
      this.certMsgStyle = true;
      this.quote.vet_certificate_submitted = 1;
      this.vetCertMsg = "Are you sure you have uploaded the vet certificate?"
    } else {
      this.certMsgStyle = false;
      this.quote.vet_certificate_submitted = 0;
      this.vetCertMsg = "Are you sure you did not upload the vet certificate yet?"
    }
    this.modalService.open(vetCert, { centered: true });
  }

  submit_vet_certificate() {
    let data: any = '';
    data = {
      quote_id: this.quote.id,
      vet_certificate_submitted: this.quote.vet_certificate_submitted
    };
    this.quoteService.submitVetCertificate(data)
      .subscribe(
        (response: any) => {
          this.modalService.dismissAll();
          if (response.success) {
            this.quote.vet_cert_upload_date = formatDate(new Date(), 'dd-MM-yyyy HH:mm a', 'en-US');
            this._snackBar.open(response.message, '', {
              duration: 5000,
            });
          } else {
            this._snackBar.open(response.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

        });
  }

}
